import React from 'react';
import { compose, withState, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { LifeCycleThis } from '@mm/utils';
import AudiencesModel from '@mm/state/model/AudiencesModel';
import AdAccountModel from '@mm/state/model/AdAccountModel';
import AdAudienceCRUDActions from '@mm/state/actions/AdAudienceCRUDActions';
import './AdAudience.scss';
import { StoreState } from '@mm/state/store-interfaces';
import { Dispatch } from 'redux';
import refreshIcon from 'assets/icons/refresh-cw.svg';
import successIcon from 'assets/icons/check-circle.svg';
import failureIcon from 'assets/icons/alert-triangle.svg';
import classNames from 'classnames';

const mapStateToProps = (state: StoreState) => {
  return {
    currentAudience: state.audiences.audienceDetails,
    activeFacebookPageId:
      state.chatbot.activeChatbot &&
      state.chatbot.activeChatbot.connectedPages[0].id,
  };
};

function mapDispatchToProps(dispatch: Dispatch<StoreState>) {
  return {
    syncAdAudience: (fbPageId: number, audienceId: number, remoteId: string) =>
      dispatch(AdAudienceCRUDActions.retrieve(fbPageId, audienceId, remoteId)),
  };
}

type PropsFromState = ReturnType<typeof mapStateToProps>;
type PropsFromDispatch = ReturnType<typeof mapDispatchToProps>;

type StatusBlockProps = {
  icon: string;
  status: string;
};

type OuterProps = {
  className?: string;
  audienceId?: number;
  remoteId?: string;
};

type InnerProps = PropsFromState &
  PropsFromDispatch &
  StatusBlockProps & {
    currentAudience: AudiencesModel;
    activeFacebookPageId: number;
    adAccounts: AdAccountModel[];
    status: string;
    icon: string;
    setAdSyncStatus: (status: string) => void;
    setAdSyncStatusIcon: (icon: string) => void;
  };

const AdSyncStatusBlock = (props: StatusBlockProps) => {
  const { icon, status } = props;
  return (
    <div className="ad-audience__inner-wrapper">
      <div className="ad-audience__sync-icon">
        <img src={icon} alt="" />
      </div>
      <div className="ad-audience__sync-status">{status}</div>
    </div>
  );
};

async function componentDidMount(this: LifeCycleThis<InnerProps & OuterProps>) {
  const {
    activeFacebookPageId,
    currentAudience,
    setAdSyncStatus,
    setAdSyncStatusIcon,
    syncAdAudience,
    remoteId: remoteIdProp,
    audienceId: audienceIdProp,
  } = this.props;

  const audienceId = currentAudience?.id || audienceIdProp;
  const adAudience = currentAudience?.adAudience;
  const remoteId = (adAudience && adAudience.remoteId) || remoteIdProp;
  if (remoteId && audienceId) {
    const result = await syncAdAudience(
      activeFacebookPageId,
      audienceId,
      String(remoteId),
    );
    if (result && result.adAudience) {
      setAdSyncStatusIcon(successIcon);
      setAdSyncStatus('Audience successfully synced');
    } else {
      setAdSyncStatusIcon(failureIcon);
      setAdSyncStatus('Sync failed, try again');
    }
  }
}

const enhance = compose<InnerProps, OuterProps>(
  connect(mapStateToProps, mapDispatchToProps),
  withState('status', 'setAdSyncStatus', 'Audience is syncing'),
  withState('icon', 'setAdSyncStatusIcon', refreshIcon),
  lifecycle<InnerProps, {}>({ componentDidMount }),
);

const AdAudience = (props: InnerProps & OuterProps) => {
  const { icon, status, className } = props;
  return (
    <div className={classNames(className, 'ad-audience__main-container')}>
      <AdSyncStatusBlock icon={icon} status={status} />
    </div>
  );
};

export default enhance(AdAudience);
